export default __webpack_public_path__ + "static/media/36I-114275_-20444_0.d0ca09fe.jpg";